import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { DynamicFieldModel } from '../dynamic-field-model';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzImageModule } from 'ng-zorro-antd/image';
import { PostService } from 'src/app/pages/post/post.service';

@Component({
  selector: 'app-dyanmic-form-img-file',
  imports: [
    NzUploadModule,
    NzIconModule,
    NzFormModule,
    FormsModule,
    NzImageModule,
    ReactiveFormsModule],
  templateUrl: './dyanmic-form-img-file.component.html',
  styleUrl: './dyanmic-form-img-file.component.scss'
})
export class DyanmicFormImgFileComponent {
  @Input() formGroup!: FormGroup;
  @Input() field!: DynamicFieldModel;
  @Input() multiple = false;

  loading: Boolean = false;
  image: string = null;
  fileList: NzUploadFile[] = [];
  removedFiles: NzUploadFile[] = [];
  constructor(private postService: PostService) { }

  ngOnInit(): void {
    const value = this.formGroup.controls[this.field.name]?.value;

    if (Array.isArray(value) && value.length > 0) {
      this.fileList = value
        .filter(img => img && (typeof img === 'string' || img.url))
        .map((img: any) => {
          const url = typeof img === 'string' ? img : img.url;

          return {
            uid: img.uid || url,
            name: img.name || (typeof url === 'string' ? url.split('/').pop() : 'image'),
            status: 'done',
            url: url
          };
        }) as NzUploadFile[];
    } else {
      //no image means empty list
      this.fileList = [];
    }
  }

  handleChange({ file, fileList }: { file: NzUploadFile; fileList: NzUploadFile[] }) {

    // Remove invalid items
    this.fileList = fileList.filter(f => f.originFileObj || f.url);

    if (file.originFileObj && !file['uploaded']) {
      file['uploaded'] = true;
      file.status = 'uploading';

      this.postService.getUploadImage(file.originFileObj).subscribe({
        next: res => {
          if (res?.data) {
            file.uid = res.data.uid;
            file.url = res.data.url;
            file.name = res.data.name;
            file.status = 'done';
            file['originalFile'] = file.originFileObj;

            this.updateFormControl();
          }
        },
        error: () => {
          file.status = 'error';
          file['uploaded'] = false;
        }
      });
    } else {
      this.updateFormControl();
    }
  }

  private updateFormControl() {
    const validFiles = this.fileList.filter(f => f.status === 'done');

    this.formGroup.controls[this.field.name]?.setValue(
      validFiles.map(f => ({
        uid: f.uid,
        name: f.name,
        url: f.url,
        // thumbUrl: f.url,
        originalFile: f.originFileObj || f['originalFile'] || null
      }))
    );
  }

  handleRemove = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.filter(f => f.uid !== file.uid);

    this.updateFormControl();

    return true;
  };

  beforeUpload = (file: NzUploadFile): boolean => {
    const rawFile = file as unknown as File;
    if (!rawFile) {
      console.error('Invalid file object');
      return false;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.image = reader.result as string;
    };

    reader.readAsDataURL(rawFile);
    return true;
  };
}
